import { useState, useCallback, useMemo } from "react";
import { createTheme } from "@mui/material/styles";

import { registerService } from "../service-provider/ServiceRegistry";

export const MUIComponentsTheme = createTheme({
  palette: {
    primary: {
      light: "#93BCF2", //light and dark shades generated based on the main color using MUI guidelines https://mui.com/material-ui/customization/color/#playground
      main: "#7FA8DE", //main color - $esic-light-green from esic-ui-constants
      dark: "#007bff",
      contrastText: "#fff",
    },
  },
  typography: {
    fontFamily: ["Segoe UI", "Tahoma", "Geneva", "Verdana", "sans-serif"].join(","),
  },
});

export interface ThemeService {
  theme: string;
  changeTheme: (theme: string) => void;
  themeClass: (themeClassNames: Array<string>, regularClassNames?: Array<string>) => string;
}

export function useTheme(): ThemeService {
  const themes = useMemo(() => ["light", "dark"], []);
  const currentTheme = localStorage.getItem("theme") || themes[0];
  const [theme, setTheme] = useState(currentTheme);

  const changeTheme = useCallback(
    (theme: string) => {
      if (themes.indexOf(theme) > -1) {
        setTheme(theme);
        localStorage.setItem("theme", theme);
      }
    },
    [themes]
  );

  const themeClass = useCallback(
    (themeClassNames: Array<string>, regularClassNames: Array<string> = []) => {
      const themeClassArray = themeClassNames.map((className: string) =>
        className ? `${className}-${theme}` : ""
      );
      const themeClassString = themeClassArray.concat(regularClassNames).join(" ");

      return themeClassString; // eg. 'themeClassNames1-themeName1 themeClassNames2-themeName2 regularClassName1 regularClassName2'
    },
    [theme]
  );

  return { theme, changeTheme, themeClass };
}

export default registerService(useTheme);
